import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { provideHttpClient, withInterceptorsFromDi, HttpClientModule } from '@angular/common/http';
import { LayoutModule } from "@progress/kendo-angular-layout";

// Telerik
import { WindowModule, DialogsModule } from '@progress/kendo-angular-dialog'
import { TooltipsModule } from '@progress/kendo-angular-tooltip';
import { UploadsModule } from '@progress/kendo-angular-upload';

// Modules
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';
import { RedeploymentOrdersModule } from './modules/redeployment-orders/redeployment-orders.module'; 
import { AuthUsersModule } from './modules/auth-users/auth-users.module';
import { ItemsModule } from './modules/items/items.module';
import { BenchTemplatesModule } from './modules/bench-templates/bench-templates.module';
import { CheckoutsModule } from './modules/checkouts/checkouts.module';
import { CollectionsModule } from './modules/collections/collections.module';
import { SecurityRolesModule } from './modules/security-roles/security-roles.module';

// Utilities
import { AuthInterceptor } from './core/utilities/auth.interceptor';
import { AuthenticationService } from './core/services/authentication.serivce';
import { SearchService } from './core/services/search.service';
import { RouterExtensionsService } from './core/services/router-extensions.service';

import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppBarComponent } from './shared/components/app-bar/app-bar.component';
import { FooterBarComponent } from './shared/components/footer-bar/footer-bar.component';
import { FeedbackMessagesComponent } from './shared/components/feedback-messages/feedback-messages.component';
import { NotificationService } from '@progress/kendo-angular-notification';
import { MiscellaneousItemsModule } from './modules/miscellaneous-items/miscellaneous-item-module';
import { ListBoxModule } from '@progress/kendo-angular-listbox';
import { BundlesModule } from './modules/bundles/bundles.module';
import { FulfillmentOrdersModule } from './modules/fulfillment-orders/fulfillment-orders.module';

@NgModule({ declarations: [
        AppComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        LayoutModule,
        BrowserAnimationsModule,
        CoreModule,
        AppBarComponent,
        FooterBarComponent,
        FeedbackMessagesComponent,
        WindowModule,
        DialogsModule,
        TooltipsModule,
        ListBoxModule,
        UploadsModule,
        AppRoutingModule,
        RedeploymentOrdersModule,
        AuthUsersModule,
        ItemsModule,
        BenchTemplatesModule,
        CheckoutsModule,
        CollectionsModule,
        BundlesModule,
        SecurityRolesModule,
        FulfillmentOrdersModule,
        MiscellaneousItemsModule,
        HttpClientModule
  ],
  providers: [
        AuthenticationService,
        SearchService,
        RouterExtensionsService,
        NotificationService,
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }
